import type { Theme } from '@mui/material';

export const styles = {
  header: (theme: Theme) => ({
    backgroundColor: theme.colors.neutral[300],
    justifyContent: 'space-between',
    alignItems: 'center',
  }),

  content: (theme: Theme) => ({
    backgroundColor: theme.colors.neutral[200],
  }),
};
